/**
 * Главната навигация — ЕДИН списък за хедъра и за мобилното меню.
 *
 * Преди двата бяха разписани поотделно (по пет <Link> на всяко място) и нова
 * страница трябваше да се добави на две места; разминеше ли се нещо, на телефон
 * просто липсваше точка от менюто.
 *
 * Иконите са със същия почерк като останалите в хедъра (24px мрежа, само
 * контури, заоблени краища) — на телефон редът без икона е само текст и
 * списъкът не се чете с поглед.
 */

const STROKE = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

const HomeIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...STROKE}>
    <path d="M3.5 10.6 12 3.6l8.5 7" />
    <path d="M5.8 9.4V19a1.6 1.6 0 0 0 1.6 1.6h9.2A1.6 1.6 0 0 0 18.2 19V9.4" />
    <path d="M9.8 20.6v-5.2h4.4v5.2" />
  </svg>
);

// Арката е знакът на кориците — същата форма стои на всяка от тях.
const CoversIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...STROKE}>
    <rect x="4.5" y="3" width="15" height="18" rx="2" />
    <path d="M8 3v18" />
    <path d="M11 17.5v-3.2a2.6 2.6 0 0 1 5.2 0v3.2" />
  </svg>
);

const VoucherIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...STROKE}>
    <rect x="3.2" y="9.4" width="17.6" height="11.4" rx="1.8" />
    <path d="M3.2 13.6h17.6" />
    <path d="M12 9.4v11.4" />
    <path d="M12 9.4H8a2.2 2.2 0 1 1 0-4.4c2.6 0 4 4.4 4 4.4Z" />
    <path d="M12 9.4h4a2.2 2.2 0 1 0 0-4.4c-2.6 0-4 4.4-4 4.4Z" />
  </svg>
);

// Компас — марката е за пътуване, а кръгът държи реда спокоен до другите.
const AboutIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...STROKE}>
    <circle cx="12" cy="12" r="8.8" />
    <path d="m15.6 8.4-2.2 5-5 2.2 2.2-5 5-2.2Z" />
  </svg>
);

const BlogIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...STROKE}>
    <rect x="3.4" y="4.8" width="17.2" height="14.4" rx="2" />
    <path d="M7 9.2h6" />
    <path d="M7 12.6h10" />
    <path d="M7 16h10" />
  </svg>
);

export const NAV_ITEMS = [
  { href: '/', label: 'Начало', match: 'exact', Icon: HomeIcon },
  { href: '/covers', label: 'Корици', match: 'prefix', Icon: CoversIcon },
  { href: '/voucher', label: 'Ваучер', match: 'exact', Icon: VoucherIcon },
  { href: '/about-us', label: 'За нас', match: 'exact', Icon: AboutIcon },
  { href: '/blog', label: 'Блог', match: 'prefix', Icon: BlogIcon },
];

/** `/blog/нещо` подчертава „Блог"; `/voucher-preview` НЕ подчертава „Ваучер". */
export function isNavItemActive(item, pathname) {
  if (!pathname) {
    return false;
  }
  return item.match === 'prefix' ? pathname.startsWith(item.href) : pathname === item.href;
}

/** Индексът на активната точка или `null`, ако сме извън менюто. */
export function activeNavItemIndex(pathname) {
  const index = NAV_ITEMS.findIndex((item) => isNavItemActive(item, pathname));
  return index === -1 ? null : index;
}
